import React from "react";

interface CustomStrategyDisplayProps {
  targetsDisplayData?: string[];
}

const CustomStrategyDisplay = ({
  targetsDisplayData,
}: CustomStrategyDisplayProps) => {
  return (
    targetsDisplayData && (
      <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row" }}>
        <div style={{ marginRight: 4 }}>Targets: </div>
        {targetsDisplayData.map((percent, index) => {
          return (
            <div key={index} style={{ marginRight: 3 }}>
              {percent}
            </div>
          );
        })}
      </div>
    )
  );
};

export default CustomStrategyDisplay;
